import PropTypes from 'prop-types';

/**
 * @typedef {object} Currency
 * @property {number} value - the amount of the currency
 * @property {string} code - the ISO 4217 currency code
 */

/**
 * @typedef {object} CurrencyPropType
 * @property {number} value - the amount of the currency
 * @property {string} code - the ISO 4217 currency code
 * @property {number} extras
 */

/**
 * @type {Currency}
 */

export let Currency;

export const CurrencyPropType = PropTypes.shape({
  value: PropTypes.number,
  code: PropTypes.string,
  extras: PropTypes.number,
});
